import classNames from "classnames";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useLegislationOptionsQuery } from "../../../../services";
import Select from "../_select";
import "./style.scss";

interface CodeSearchFilterProps {
  isActive: boolean;
  isDisabled: boolean;
  selectedCode: string;
  article: string;
  onActivate: () => void;
  onCodeChange: (value: string) => void;
  onArticleChange: (value: string) => void;
}

export function CodeSearchFilter({
  isActive,
  isDisabled,
  selectedCode,
  article,
  onActivate,
  onCodeChange,
  onArticleChange,
}: CodeSearchFilterProps) {
  const [localArticle, setLocalArticle] = useState(article);

  useEffect(() => {
    setLocalArticle(article);
  }, [article]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onArticleChange(localArticle);
    }, 500);

    return () => clearTimeout(timeout);
  }, [localArticle]);

  const handleInteraction = () => {
    if (!isActive) {
      onActivate();
    }
  };

  const { data, isPending } = useLegislationOptionsQuery();

  return (
    <div
      className={classNames(
        "code-search-filter",
        isActive && "code-search-filter-active",
        isDisabled && "code-search-filter-disabled",
      )}
      onClick={handleInteraction}
    >
      <div className="code-search-filter-header">
        <div
          className={classNames(
            "code-search-filter-radio ",
            isActive ? "code-search-filter-radio-active" : "",
          )}
        >
          {isActive && <div className="code-search-filter-radio-dot" />}
        </div>
        <span
          className={classNames(
            "code-search-filter-label ",
            isActive ? "code-search-filter-label-active" : "",
          )}
        >
          Pesquisa por Codigo
        </span>
      </div>

      <div className="code-search-filter-fields">
        <div>
          <label className="code-search-filter-field-label">
            Codigos e Normas em Destaque
          </label>

          <Select
            options={(data || []).map((data) => ({
              label: `${data.apelidos[0]}${
                data.apelidos.length > 1 ? " - " + data.apelidos[1] : ""
              }`,
              value: data.id,
            }))}
            value={selectedCode}
            searchable
            onSelect={(value) => {
              onCodeChange(value);
              handleInteraction();
            }}
            onFocus={handleInteraction}
            disabled={isDisabled}
            loading={isPending}
            placeholder="Selecione..."
          />
        </div>

        <div>
          <label className="code-search-filter-field-label">Artigo</label>
          <Form.Control
            type="text"
            placeholder="Ex: Art. 5"
            value={localArticle}
            onChange={(e) => {
              setLocalArticle(e.target.value);
              handleInteraction();
            }}
            onFocus={handleInteraction}
            disabled={isDisabled}
            size="sm"
          />
        </div>
      </div>
    </div>
  );
}
